import React, { useState } from 'react'
import styles from './ViewerGdprSection.module.scss'
import { Button } from 'components/shared'
import { PageTopContainer } from 'pages/utils'
import { Api, User } from 'utilities'
import { inject } from 'mobx-react'
import { GENERAL_STORE, GeneralStore, VIEWERS_STORE, ViewersStore } from 'store'
import { observer } from 'mobx-react-lite'

export interface ViewerGdprSectionProps {
  [VIEWERS_STORE]?: ViewersStore
  [GENERAL_STORE]?: GeneralStore
}

const ViewerGdprSectionComponent = (props: ViewerGdprSectionProps) => {
  const {
    [VIEWERS_STORE]: viewersStore,
    [GENERAL_STORE]: generalStore
  } = props

  const [exportLoading, setExportLoading] = useState(false)
  const [lastExportResult, setLastExportResult] = useState<Record<string, unknown> | null>(null)
  const [showExportResult, setShowExportResult] = useState(false)

  const email = viewersStore?.currentViewer?.emailAddress?.trim()
  const isAdmin = User.isAdmin()

  if (!isAdmin || !email) return null

  const handleExport = async () => {
    if (!generalStore || !email) return
    setExportLoading(true)
    setLastExportResult(null)
    generalStore.setLoadingOn()
    try {
      const result = await Api.post<Record<string, unknown>>(
        '/gdpr/export',
        { email },
        'mainApi'
      )
      generalStore.setLoadingOff()
      setExportLoading(false)
      setLastExportResult(result ?? null)
      setShowExportResult(true)
      generalStore.showSuccess('User data export completed. View the result below.')
      if (result) {
        console.info('GDPR export result:', result)
      }
    } catch (err) {
      generalStore.setLoadingOff()
      setExportLoading(false)
      generalStore.handleApiError(err as Error)
    }
  }

  return (
    <PageTopContainer preset='white' className={styles.container}>
      <h3 className={styles.title}>GDPR (Super Admin)</h3>
      <p className={styles.description}>
        Export or erase this viewer&apos;s personal data across all services. Requires SUPER_ADMIN role.
      </p>
      <div className={styles.buttonsRow}>
        <Button
          onClick={handleExport}
          disabled={exportLoading}
          preset='secondary'
        >
          {exportLoading ? 'Exporting…' : 'Export user data'}
        </Button>
      </div>
      {lastExportResult != null && (
        <div className={styles.exportResult}>
          <button
            type='button'
            className={styles.exportResultToggle}
            onClick={() => setShowExportResult((v) => !v)}
          >
            {showExportResult ? 'Hide export result' : 'Show export result'}
          </button>
          {showExportResult && (
            <pre className={styles.exportResultJson}>
              {JSON.stringify(lastExportResult, null, 2)}
            </pre>
          )}
        </div>
      )}
    </PageTopContainer>
  )
}

const ViewerGdprSection = inject(
  VIEWERS_STORE,
  GENERAL_STORE
)(observer(ViewerGdprSectionComponent))

export { ViewerGdprSection }
